import { Tooltip, makeStyles, tokens } from "@fluentui/react-components";
import type { DatasetViewColumn } from "../../../../api/types";
import { jsonProvenanceLabel } from "./jsonProvenance";

const useStyles = makeStyles({
  badge: {
    border: "none",
    borderRadius: tokens.borderRadiusSmall,
    backgroundColor: tokens.colorPalettePurpleBackground2,
    color: tokens.colorPalettePurpleForeground2,
    cursor: "help",
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: "16px",
    padding: "0 4px",
  },
});

export default function JsonProvenanceBadge({ column }: { column: DatasetViewColumn }) {
  const styles = useStyles();
  return (
    <Tooltip content={`Promoted from JSON: ${jsonProvenanceLabel(column)}`} relationship="description">
      <span className={styles.badge} aria-label={`Promoted from JSON: ${jsonProvenanceLabel(column)}`}>
        JSON
      </span>
    </Tooltip>
  );
}